import script from "./WebAssistantLauncher.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebAssistantLauncher.vue?vue&type=script&lang=ts&setup=true"

import "./WebAssistantLauncher.vue?vue&type=style&index=0&id=053ed404&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053ed404"]])

export default __exports__